import type { RequestRegistrationDto } from '@nestjs-boilerplate/types';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { requestRegistration } from '../api/auth.api';

/**
 * Step 1 of gated registration: request an invite code from an approver.
 * The approver (a superadmin) receives a single-use code and relays it.
 */
export function useRequestRegistration() {
  return useMutation({
    mutationFn: (data: RequestRegistrationDto) => requestRegistration(data),
    onError: (error: Error) => {
      toast.error(error.message || 'Could not request a registration code. Please try again.');
    },
  });
}
